import { useState } from 'react';
import { Popover } from '../../../../../../common/components/Popover/Popover';
import { Help } from '../../../../../../common/components/icons/Help';
import { PopUp } from '../../../../../../common/components/popups/PopUp/PopUp';
import { useMobile } from '../../../../../../common/services/screenSize/ScreenSizeService';
import {
  DentalPricingView,
  Value,
  HelpIconWrapper,
  SubValue,
  StyledOkButton,
  View,
  PriceText,
  Description,
} from './DentalPricing.styles';
import { DentalPricingTooltip } from './DentalPricingTooltip/DentalPricingTooltip';
import { DentalPriceBracket, formatDentalPricingNumber } from './getDentalPricing';

interface Props {
  readonly isVerified: boolean;
  readonly pricingBracket: DentalPriceBracket;
  readonly importedAt?: Date;
}

export const DentalPricing = ({ isVerified, pricingBracket, importedAt }: Props) => {
  const [showingPopup, setShowing] = useState(false);
  const isMobile = useMobile();

  const handleHelpClick = () => {
    setShowing(true);
  };

  const handleClose = () => {
    setShowing(false);
  };

  const toolTip = <DentalPricingTooltip isVerified={isVerified} importedAt={importedAt} />;

  const helpIconWrapper = isMobile ? (
    <>
      <HelpIconWrapper onClick={handleHelpClick}>
        <Help />
      </HelpIconWrapper>
      <PopUp showing={showingPopup} onClose={handleClose}>
        {toolTip}
        {isMobile && <StyledOkButton onClick={handleClose}>Ok</StyledOkButton>}
      </PopUp>
    </>
  ) : (
    <HelpIconWrapper>
      <Popover content={toolTip}>
        <Help />
      </Popover>
    </HelpIconWrapper>
  );

  return (
    <DentalPricingView>
      <Value>
        <View>
          <PriceText priceBracket={pricingBracket}>
            {formatDentalPricingNumber(pricingBracket)}
          </PriceText>
          <Description>
            Check-up and clean (without fluoride & X-ray){' '}
            {!isVerified && <SubValue>Unverified</SubValue>}
            {helpIconWrapper}
          </Description>
        </View>
      </Value>
    </DentalPricingView>
  );
};
